import { render, staticRenderFns } from "./TenantLayout.vue?vue&type=template&id=0a04e7b2&scoped=true"
import script from "./TenantLayout.vue?vue&type=script&lang=js"
export * from "./TenantLayout.vue?vue&type=script&lang=js"
import style0 from "./TenantLayout.vue?vue&type=style&index=0&id=0a04e7b2&prod&lang=css"
import style1 from "./TenantLayout.vue?vue&type=style&index=1&id=0a04e7b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a04e7b2",
  null
  
)

export default component.exports